import React from 'react';

/**
 * PageContainer - Reusable page container component with standard padding
 * 
 * @param {React.ReactNode} children - Page content
 * @param {string} className - Additional CSS classes
 */
const PageContainer = ({ children, className = '' }) => {
  return (
    <div className={`py-6 px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
};

export default PageContainer;
